import { createStoreChunk } from '@core/store'

type TCreatorProfileOfferState = {
    candidate: boolean
    checking: boolean
    assignmentSettled: boolean
    welcomeLinkSeen: boolean
}

export const creatorProfileOfferStore = createStoreChunk<TCreatorProfileOfferState>(
    'creatorProfileOffer',
)({
    initialState: {
        candidate: false,
        checking: false,
        assignmentSettled: false,
        welcomeLinkSeen: false,
    },
    actions: {
        setCandidate: (candidate: boolean) => ({ candidate }),
        setChecking: (checking: boolean) => ({ checking }),
        setAssignmentSettled: (assignmentSettled: boolean) => ({ assignmentSettled }),
        markWelcomeLinkSeen: () => ({ welcomeLinkSeen: true }),
    },
})
